import type { FunctionalComponent } from 'vue'

export const UserIcon = defineComponent({
  setup() {
    return () => (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 0C11.3132 -1.95685e-08 12.6136 0.258658 13.8268 0.761205C15.0401 1.26375 16.1425 2.00035 17.0711 2.92893C17.9997 3.85752 18.7362 4.95991 19.2388 6.17317C19.7413 7.38642 20 8.68678 20 10C20 11.3132 19.7413 12.6136 19.2388 13.8268C18.7362 15.0401 17.9997 16.1425 17.0711 17.0711C16.1425 17.9997 15.0401 18.7362 13.8268 19.2388C12.6136 19.7413 11.3132 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 3.95203e-08 10 0ZM12.7778 7.22222C12.7778 7.95894 12.4851 8.66547 11.9642 9.18641C11.4433 9.70734 10.7367 10 10 10C9.26329 10 8.55675 9.70734 8.03582 9.18641C7.51488 8.66547 7.22222 7.95894 7.22222 7.22222C7.22222 6.48551 7.51488 5.77897 8.03582 5.25804C8.55675 4.7371 9.26329 4.44444 10 4.44444C10.7367 4.44444 11.4433 4.7371 11.9642 5.25804C12.4851 5.77897 12.7778 6.48551 12.7778 7.22222ZM10 12.2178H6.29667C5.52333 12.2178 4.86111 13.0733 4.58333 13.9067C5.25889 14.9589 7.17556 16.6444 10 16.6689C12.8244 16.6933 14.7844 14.8467 15.4167 13.9067C15.1389 13.0733 14.4767 12.2178 13.7033 12.2178H10Z"
          fill="var(--colors-bg-icon-primary)"
        />
      </svg>
    )
  },
})

export const BgeUserIcon: FunctionalComponent = (props) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clip-path="url(#clip0_123705_4459)">
        <mask id="mask0_123705_4459" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
          <circle cx="16" cy="16" r="16" fill="#C4C4C4" />
        </mask>
        <g mask="url(#mask0_123705_4459)">
          <circle cx="16" cy="16" r="16" fill="#434F62" fill-opacity="0.9" />
          <circle cx="16" cy="13.5" r="7.5" fill="url(#paint0_radial_123705_4459)" />
          <circle cx="16" cy="13.5" r="7.5" fill="url(#paint1_radial_123705_4459)" />
          <mask id="mask1_123705_4459" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="-14" y="23" width="60" height="60">
            <circle cx="16" cy="53" r="30" fill="#FFDD00" />
          </mask>
          <g mask="url(#mask1_123705_4459)">
            <g filter="url(#filter0_i_123705_4459)">
              <circle cx="16" cy="53" r="30" fill="#FFDD00" />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <filter id="filter0_i_123705_4459" x="-14" y="23" width="60" height="64" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_123705_4459" />
        </filter>
        <radialGradient id="paint0_radial_123705_4459" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(14.5 10.5) rotate(61.7503) scale(19.0148)">
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0.4" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_123705_4459"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.25 17.25) rotate(-102.804) scale(5.64026 7.6424)"
        >
          <stop stop-color="#FFC400" stop-opacity="0.22" />
          <stop offset="1" stop-color="#FFDD33" stop-opacity="0" />
        </radialGradient>
        <clipPath id="clip0_123705_4459">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
